<template>
  <div class="program-page">
    <div v-for="(item, index) in programList" :key="index" class="item-div">
      <p class="item-title" v-html="item.title"></p>

      <div class="second img-right">
        <img :src="imageSrc(item.num)" alt="">
        <div class="desc-div">
          <p class="desc">{{item.desc}}</p>
          <ul>
            <li>
              <div><p>활동 시기 :&nbsp;</p></div>
              <div><p>{{item.date}}</p></div>
            </li>
            <li>
              <div><p>활동 장소 :&nbsp;</p></div>
              <div><p>{{item.place}}</p></div>
            </li>
            <li>
              <div><p>활동 대상 :&nbsp;</p></div>
              <div><p>{{item.target}}</p></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LocalYellowWaveChallenge',
  data() {
    return {
      programList: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.programList = [
        {
          num: 2,
          title: '노란물결 : 전남드래곤즈를 이겨라',
          desc: '“노란물결 : 전남드래곤즈를 이겨라”는 선수들이 연고지 내 초등학교를 방문해 학생과 함께 레크레이션, 팬 사인회 등의 활동을 통해 즐겁운 추억을 만들며 긍정적인 스포츠 문화 형성과 건강한 성장을 돕고자 하는 프로그램입니다.',
          date: '3월 ~ 10월, 방학제외 / 11:30 ~ 13:00',
          place: '광양, 순천, 여수 초등학교',
          target: '초등학생 / 1회 최대 40명'
        },
      ];
    },

    imageSrc(num) {
      return require(`@/assets/img/club/local_0${num}.png`);
    },
  },
};
</script>

<style scoped>
.total-year-records {
  padding-right: 0;
}

.total-year-records table {
  min-width: auto;
}

.program-page .item-div .desc {
  word-break: normal !important;
}

@media (max-width: 959px) {
  .total-year-records table {
    min-width: 800px;
  }
}
</style>
